import { z } from "zod";

export const dateTransformer = z.any().transform((val, ctx) => {
  if (typeof val === "string") {
    const normalizedVal = val.trim();
    const hasTimezoneOffset = /[+-]\d{2}:?\d{2}$/.test(normalizedVal);

    if (
      !normalizedVal.endsWith("Z") &&
      !hasTimezoneOffset &&
      normalizedVal.includes("T")
    ) {
      return new Date(normalizedVal + "Z");
    }
    return new Date(val);
  }

  if (typeof val === "number") {
    return new Date(val);
  }

  if (val instanceof Date) {
    return val;
  }

  const date = new Date(val);
  if (isNaN(date.getTime())) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: "Invalid date format",
    });
    return z.NEVER;
  }

  return date;
});
